export default __webpack_public_path__ + "static/media/phivolcs_seal2.92decdf6.png";